<section>
  <aside>
    <h2><span>Novedades </span>Pasadas</h2>
  </aside>
  <!-- <div class="filtros"></div> -->
  <main>
    <swiper-container
      id="swiper-container-pasados"
      class="swiper-container"
      navigation="{
            nextEl: '.button-next',
            prevEl: '.button-prev'
          }"
      pagination="false"
      slides-per-view="2.1"
      init="false"
    >
      <swiper-slide *ngFor="let elemento of eventosPasados$" class="card">
        <span
          *ngIf="elemento.id"
          routerLink="/novedades/{{ elemento.id }}"
        ></span>
        <a href="/novedades/{{ elemento.id }}">
          <div class="image__container">
            <img
              *ngIf="elemento['detailImage']"
              [src]="img_base + elemento['detailImage']"
              alt=""
            />
          </div>
          <div class="data__container">
            <div class="first__data">
              <h5>{{ elemento.nombre }}</h5>
              <p *ngIf="elemento.categorias | categoriaFilter: 'ods'">
                ODS: {{ elemento.categorias | categoriaFilter: "ods" }}
              </p>
              <p>{{ elemento.fechaInfoInicio | date: "d MMM. yyyy" }}</p>
            </div>
          </div>
        </a>
      </swiper-slide>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </swiper-container>
  </main>
</section>
